export const environment = {
  production: true,
  // Los reemplaza el pipeline antes de compilar (bitbucket-pipelines.yml).
  appVersion: '1.3.1',
  appBuild: '197',
  coreApiUrl: 'https://api.develop.itdux.com.bo/core',
  coreApiUrlWs: 'wss://api.develop.itdux.com.bo/core',
};
